export default __webpack_public_path__ + "static/media/2448.d7467e8e.png";